import {
  FaLaptopCode,
  FaPalette,
  FaDesktop,
  FaLanguage,
  FaBullhorn,
  FaCut,
} from 'react-icons/fa';

// Single source of truth for both the course grid and the course detail page.
// `Icon` is the component itself so each consumer can size it.
export const courses = [
  {
    id: 'web-development',
    title: 'Web Development',
    Icon: FaLaptopCode,
    description: 'Learn modern web development with HTML, CSS, JavaScript, and React.',
    features: ['Frontend & Backend', 'Responsive Design', 'API Integration'],
    level: 'Beginner to Advanced',
    duration: '12 Weeks',
    durationLong: '3 months',
    price: '8000 BDT',
    schedule: 'Monday & Wednesday',
    instructor: 'ADIL HUSSAIN',
    details: [
      'HTML5 & CSS3 fundamentals',
      'JavaScript programming',
      'React.js framework',
      'Responsive design',
      'Web development best practices',
    ],
    highlights: [
      'Hands-on projects',
      'Industry expert guidance',
      'Certificate upon completion',
      'Job placement assistance',
      'Lifetime access to materials',
    ],
  },
  {
    id: 'graphics-design',
    title: 'Graphics Design',
    Icon: FaPalette,
    description: 'Master digital design tools and create stunning visual content.',
    features: ['Adobe Creative Suite', 'UI/UX Design', 'Brand Identity'],
    level: 'All Levels',
    duration: '8 Weeks',
    durationLong: '2 months',
    price: '4000 BDT',
    schedule: 'Tuesday & Thursday',
    instructor: 'RAFID RAHMAN',
    details: [
      'Adobe Photoshop & Illustrator',
      'Color theory and typography',
      'Logo design',
      'Digital illustration',
      'Brand identity design',
    ],
    highlights: [
      'Design portfolio building',
      'Industry-standard tools',
      'Creative project work',
      'Design principles',
      'Client project experience',
    ],
  },
  {
    id: 'basic-computer',
    title: 'Basic Computer',
    Icon: FaDesktop,
    description: 'Essential computer skills and software applications for beginners.',
    features: ['Office Applications', 'Internet Skills', 'File Management'],
    level: 'Beginner',
    duration: '4 Weeks',
    durationLong: '1 month',
    price: '1000 BDT',
    schedule: 'Monday & Friday',
    instructor: 'ADIL HUSSAIN & ASIFUR RAHMAN',
    details: [
      'Computer fundamentals',
      'Microsoft Office Suite',
      'Internet and email',
      'File management',
      'Basic troubleshooting',
    ],
    highlights: [
      'Practical computer skills',
      'Office software mastery',
      'Internet safety',
      'Basic troubleshooting',
      'Digital literacy',
    ],
  },
  {
    id: 'basic-english',
    title: 'Basic English',
    Icon: FaLanguage,
    description: 'Improve your English language skills for better communication.',
    features: ['Speaking Practice', 'Business Writing', 'Grammar Essentials'],
    level: 'Beginner to Intermediate',
    duration: '6 Weeks',
    durationLong: '2 months',
    price: '1000 BDT',
    schedule: 'Tuesday & Friday',
    instructor: 'ASIFUR RAHMAN',
    details: [
      'Grammar fundamentals',
      'Vocabulary building',
      'Speaking practice',
      'Reading comprehension',
      'Writing skills',
    ],
    highlights: [
      'Interactive speaking sessions',
      'Grammar workshops',
      'Writing practice',
      'Vocabulary building',
      'Pronunciation training',
    ],
  },
  {
    id: 'digital-marketing',
    title: 'Digital Marketing',
    Icon: FaBullhorn,
    description: 'Grow brands online with social media, SEO, and paid advertising.',
    features: ['Social Media Marketing', 'SEO & Content', 'Paid Ad Campaigns'],
    level: 'Beginner to Intermediate',
    duration: '8 Weeks',
    durationLong: '2 months',
    price: '4000 BDT',
    schedule: 'Sunday & Tuesday',
    instructor: 'KAWSAR HAMID',
    details: [
      'Digital marketing fundamentals',
      'Facebook & Instagram marketing',
      'Search engine optimization (SEO)',
      'Google Ads & paid campaigns',
      'Content strategy and analytics',
    ],
    highlights: [
      'Live campaign practice',
      'Real client case studies',
      'Analytics and reporting skills',
      'Certificate upon completion',
      'Freelancing guidance',
    ],
  },
  {
    id: 'cloth-swing',
    title: 'Cloth Swing',
    Icon: FaCut,
    description: 'Learn the art of clothing design and pattern making.',
    features: ['Pattern Creation', 'Fabric Selection', 'Sewing Techniques'],
    level: 'All Levels',
    duration: '10 Weeks',
    durationLong: '3 months',
    price: '5000 BDT',
    schedule: 'Wednesday & Saturday',
    instructor: 'SONIA AKHTER',
    details: [
      'Pattern making basics',
      'Fabric selection',
      'Sewing techniques',
      'Garment construction',
      'Design principles',
    ],
    highlights: [
      'Hands-on sewing practice',
      'Pattern making skills',
      'Fabric knowledge',
      'Design techniques',
      'Portfolio development',
    ],
  },
];

export const getCourse = (id) => courses.find((course) => course.id === id);
